import React, { useState } from 'react';
import { View } from 'react-native';

import { isNil } from 'lodash';
import PropTypes from 'prop-types';

import { VFButton, VFText } from '@vfgroup-oneplatform/foundation/Components';
import { LightThemeColors, useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';
import VFLottieView, { LottieTypes } from '@vfgroup-oneplatform/foundation/Components/VFLottieView';

import styles from './OfferGift.Styles';
import SummaryItem from './SummaryItem/SummaryItem';

const toggleAddOffer = (isOfferAdded, setOffer, onAddOffer, offerValues) => {
  if (isOfferAdded) {
    setOffer(offerValues.giftOfferPrice);
    onAddOffer(offerValues);
  } else {
    {
      setOffer(null);
      onAddOffer(null);
    }
  }
};
const OfferGift = ({
  titleID,

  subTitleID,
  lottieID,
  selectedValue,
  onAddOffer,
  offerValues,
}) => {
  const [offer, setOffer] = useState(null);
  const isOfferAdded = isNil(offer);

  const theme = useTheme();
  return (
    <View style={styles.container}>
      <VFLottieView
        autoPlay
        style={styles.rewardLottieViewStyle}
        type={LottieTypes.reward}
        loop={false}
        testID={lottieID}
      />

      <VFText
        style={styles.titleStyle(theme)}
        i18nKey={`Add ${offerValues.giftValue}${offerValues.giftUnit} of data for only ${offerValues.giftOfferPrice}${offerValues.currency}`}
        testID={titleID}
      />

      <VFText
        style={styles.subTitle(theme)}
        i18nKey={`Normal price ${offerValues.giftNormalPrice}${offerValues.currency}. Offer ends on ${offerValues.endDate}.`}
        testID={subTitleID}
      />

      <VFButton
        type={isOfferAdded ? 'primary' : 'tertiary'}
        onPress={() => toggleAddOffer(isOfferAdded, setOffer, onAddOffer, offerValues)}
        style={[styles.addDataButton]}
        textStyle={[styles.addDataButtonStyle]}
        title={isOfferAdded ? 'top_up_quick_action_add_data_button_text' : 'Remove'}
      />
      <View style={styles.summaryTitleContainer}>
        <VFText style={styles.summaryTitleText(theme)}>Payment Summary</VFText>
        <View style={styles.summaryDetailsContainer(theme)}>
          <SummaryItem title="Top-up" value={`${selectedValue?.value}€`} />
          {!isOfferAdded && (
            <SummaryItem
              title={`${offerValues.giftValue}${offerValues.giftUnit} data`}
              value={`${offerValues.giftOfferPrice}€`}
            />
          )}
          <SummaryItem title="Total" value={`${+selectedValue?.value + offer || 0}€`} isTitleBold />
        </View>
      </View>
    </View>
  );
};
OfferGift.defaultProps = {
  theme: LightThemeColors,
};

OfferGift.propTypes = {
  lottieID: PropTypes.string,
  titleID: PropTypes.string,
  subTitleID: PropTypes.string,
  lottietype: PropTypes.string,
  selectedValue: PropTypes.object,
  onAddOffer: PropTypes.func,
  offerValues: PropTypes.object,
};

export default OfferGift;
export { toggleAddOffer };
